import { createContext, useEffect } from "react";
import { useUnityContext } from "react-unity-webgl";
import { UnityContextHook } from "react-unity-webgl/distribution/types/unity-context-hook";
import CONFIG from "utils/config";

// Declare global Unity instance that can be accessed from JSLib
declare global {
  interface Window {
    unityInstance: any; // 'any' type since Unity's runtime type is not strictly defined
  }
}

type UnityViewerContextType = UnityContextHook | undefined;
 
export const unityViewerContext = createContext<UnityViewerContextType>(undefined);
 
export const UnityViewerContextProvider = ({ children }: { children: React.ReactNode }) => {
  const unityContextHook = useUnityContext(CONFIG.UNITY_VIEWER_PROPS);
 
  // Use useEffect to set the Unity instance once it's available
  useEffect(() => {
    if (unityContextHook.UNSAFE__unityInstance) {
      console.log("Setting Unity instance to window.unityInstance...");
      window.unityInstance = unityContextHook.UNSAFE__unityInstance;
    } else {
      console.warn("Unity instance is not yet available.");
    }
    return () => {
      if (window.unityInstance) {
        console.log("Unloading Unity instance...");
        unityContextHook.unload().then(() => {
          window.unityInstance = undefined;
          console.log("Unity instance unloaded.");
        }).catch((error) => {
          console.error("Error unloading Unity instance:", error);
        });
      }
    };
  }, [unityContextHook.UNSAFE__unityInstance]);
 
  return (
    <unityViewerContext.Provider value={unityContextHook}>
      {children}
    </unityViewerContext.Provider>
  );
};